"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomHeader = void 0;
const react_1 = __importDefault(require("react"));
const CustomHeader = ({ logoUrl, title, }) => {
    return (react_1.default.createElement("div", { className: "flex w-full custom-header items-center justify-center", style: { height: "70px" } },
        react_1.default.createElement("div", { className: "w-full px-2 custom-header-content" },
            react_1.default.createElement("div", { className: "flex items-center" },
                react_1.default.createElement("img", { src: logoUrl, style: { maxHeight: "40px" }, className: "object-contain" }),
                react_1.default.createElement("h1", { className: "font-semibold text-xl ml-2" }, title)))));
};
exports.CustomHeader = CustomHeader;
//# sourceMappingURL=CustomHeader.js.map